export default {
    comparison: {
        comparisonOptions: {
            leftType: "constantValue",
            leftValue: "",
            rightType: "constantValue",
            rightValue: ""
        }
    },
    equals: {
        equalsOptions: {
            leftType: "constantValue",
            leftValue: "",
            rightType: "constantValue",
            rightValue: ""
        }
    },
    fuzzyMatch: {
        fuzzyMatchOptions: {
            leftType: "constantValue",
            leftValue: "",
            rightType: "constantValue",
            rightValue: ""
        }
    },
    startsWith: {
        startsWithOptions: {
            prefixType: "constantValue",
            prefixValue: "",
            fullTextType: "constantValue",
            fullTextValue: ""
        }
    },
    hasValue: {
        hasValueOptions: {
            propertyType: "constantValue",
            propertyValue: ""
        }
    },
    hasEvent: {
        hasEventOptions: {
            hasEventType: "constantValue",
            hasEventValue: ""
        }
    },
    fullTextSearch: {
        fullTextSearchOptions: {
            searchInType: "constantValue",
            searchInValue: "",
            searchStringType: "constantValue",
            searchStringValue: "",
        }
    },
    fullTextSearchAnalyzed: {
        fullTextSearchOptions: {
            searchInType: "contextProperty",
            searchInValue: "",
            searchStringType: "constantValue",
            searchStringValue: "",
        }
    }
}